import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as AWS from 'aws-sdk';
import * as S3 from 'aws-sdk/clients/s3';
import { User } from '../../../core/modelos/user';
import 'rxjs/add/observable/of';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { saveAs } from 'file-saver/FileSaver';
import { Fichero } from '../../../core/modelos/fichero';
import { Cliente } from '../../../core/modelos/cliente';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { Activo } from '../../../core/modelos/activo';
import { DocumentoTicket } from '../../../core/modelos/documento_ticket';


@Injectable()
export class FileManagerService {

  onFilesChanged: BehaviorSubject<any> = new BehaviorSubject({});
  onFileSelected: BehaviorSubject<any> = new BehaviorSubject({});

  carpetaOculta = 'Anexos';

  usuarioLogueado: User;
  clienteBucket: Cliente;

  public carpetaActual: string;

  ficheroDescargado: Subject<any> = new Subject();
  ficheroDashboard: Subject<Fichero> = new Subject();
  rutaActual: Subject<string> = new Subject();
  carpetaDestino: BehaviorSubject<any> = new BehaviorSubject({}); // Se llama desde panel info para ir a la carpeta de cada proyecto

  constructor(
    private http: HttpClient,
    private notificaciones: NotificacionesService  ) {
    const sessionUsuario = JSON.parse(sessionStorage.getItem('usuarioLogueado'));
    if (sessionUsuario) {
      this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
      const cookieAdmin: Cliente = this.usuarioLogueado.cliente;
      if (cookieAdmin) {
        if (this.usuarioLogueado.rol.id === 1) {
          this.setClienteBucket(cookieAdmin);
        }
      }
    }

  }

  static categorizarFicheros(data): Array<Fichero> {
    // Variables icono font-awesome
    const base_fa = 'fa-';
    let fa_icon;
    // Tratamiento Ficheros
    const ficheros = new Array<Fichero>();
    const carpetas = data.CommonPrefixes;
    carpetas.forEach(carpeta => {
      if (carpeta.Prefix !== 'Anexos/') {
        ficheros.push(new Fichero(0, carpeta.Prefix, null, null, null, 'folder', (base_fa + 'folder')));
      }
    });
    const fileDatas = data.Contents;

    fileDatas.forEach(
      file => {
        let tipoArchivo;

        // Si no tiene extension lo trataré como una carpeta
        // tipoArchivo = 'folder';

        // Si no es una carpeta, busco su tipo
        const partes = file.Key.split('.');
        switch (partes[partes.length - 1].toLocaleLowerCase()) {
          case 'docx': tipoArchivo = 'document'; fa_icon = base_fa + 'file-word-o';
            break;
          case 'pdf': tipoArchivo = 'pdf'; fa_icon = base_fa + 'file-pdf-o';
            break;
          case 'xlsx': tipoArchivo = 'spreadsheet'; fa_icon = base_fa + 'file-excel-o';
            break;
          case 'jpg': tipoArchivo = 'image'; fa_icon = base_fa + 'file-image-o';
            break;
          case 'png': tipoArchivo = 'image'; fa_icon = base_fa + 'file-image-o';
            break;

          // Por defecto será un archivo
          default: tipoArchivo = 'file'; fa_icon = base_fa + 'file';
            break;
        }
        // Añado la condicion file.Size === 0 para distinguir las nuevas carpetas que creo
        if (tipoArchivo && file.Size !== 0) {
          ficheros.push(new Fichero(
            (file.Size / 1024).toFixed(0),
            file.Key,
            file.ETag,
            file.LastModified,
            file.StorageClass,
            tipoArchivo,
            fa_icon
          ));
        }
      });

    return ficheros;
  }

  private getBucket(): string {
    // Este metodo establece el nombre del bucket con el que trabajamos
    let bucket;
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
    // const cookieAdmin = this.cookieSrv.get('clienteAdmin');
    const clienteCookie: Cliente = this.usuarioLogueado.cliente;
    if (this.usuarioLogueado.rol.id === 1) {
      // Rol 1 tiene que definir de que cliente ve el bucket
      if (!this.clienteBucket) {
        // Si aun no lo ha definido
        if (clienteCookie) {
          // Si lo eligio antes, lo cojo de la cookie
          bucket = clienteCookie.bucketAWS;
          this.clienteBucket = bucket;
        }
        else {
          this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
          return 'Error';
        }
      } else {
        bucket = this.clienteBucket.bucketAWS;
      }
    }
    else {
      bucket = this.usuarioLogueado.cliente.bucketAWS;
    }
    return bucket;
  }

  private getS3(): S3 {
    // Este metodo sirve para configurar el acceso al S3
    let userAWS;
    let passwordAWS;
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
    if (this.usuarioLogueado.rol.id === 1) {
      // Rol 1 tiene que definir de que cliente ve el bucket
      if (!this.clienteBucket) {
        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
        return null;
      } else {
        userAWS = this.clienteBucket.userAWS;
        passwordAWS = this.clienteBucket.passwordAWS;
      }
    }
    else {
      userAWS = this.usuarioLogueado.cliente.userAWS;
      passwordAWS = this.usuarioLogueado.cliente.passwordAWS;
    }
    const s3 = new S3(
      {
        accessKeyId: userAWS,
        secretAccessKey: passwordAWS,
        region: 'eu-west-1'
      }
    );
    return s3;
  }
  setClienteBucket(cliente: Cliente) {
    // A este metodo llaman los roles admin para establecer el cliente del cual quieren consultar la info
    this.clienteBucket = cliente;
    // console.log(this.clienteBucket);

  }
  getClienteBucket(): Cliente {
    return this.clienteBucket;
  }

  uploadfile(file: File): S3.ManagedUpload {

    const carpeta = this.carpetaActual ? this.carpetaActual : null;
    // Params define el lugar donde se guarda
    const params = {
      Bucket: carpeta ? this.getBucket() + '/' + carpeta : this.getBucket(),
      Key: file.name,
      Body: file,
      ACL: 'public-read-write'
    };
    return this.getS3() != null ? this.getS3().upload(params) : null;
  }

  headObject(file: File): AWS.Request<S3.HeadObjectOutput, AWS.AWSError> {

    const carpeta = this.carpetaActual ? this.carpetaActual : '';

    const params = {
      Bucket: this.getBucket(),
      Key: carpeta + '/' + file.name
    };
    
    return this.getS3() != null ? this.getS3().headObject(params) : null;
  }

  uploadAnexoTicket(file: File, nombreFisico: string): S3.ManagedUpload {

    // Params define el lugar donde se guarda
    const params = {
      Bucket: this.getBucket(),
      Key: nombreFisico,
      Body: file,
      ACL: 'public-read-write'
    };
    return this.getS3() != null ? this.getS3().upload(params) : null;
  }
  descargarAnexoTicket(anexo: DocumentoTicket) {
    const params = {
      Bucket: this.getBucket(),
      Key: anexo.nombre_fisico,
    };

    // return params;
    if (this.getS3() != null) {
      this.getS3().getObject(params, function (err, data) {
        if (err) {
          console.log(err);
          return;
        }
        const blob = new Blob([data.Body], {
          type: ''
        });
        saveAs(blob, anexo.nombre_logico);
      });
    }

  }
  deleteAnexo(anexo: DocumentoTicket): AWS.Request<S3.DeleteObjectOutput, AWS.AWSError> {
    const params = {
      Bucket: this.getBucket(),
      Key: anexo.nombre_fisico
    };
    return this.getS3() != null ? this.getS3().deleteObject(params) : null;
  }

  newFolder(nombre: string): AWS.Request<S3.PutObjectOutput, AWS.AWSError> {
    const carpeta = this.carpetaActual ? this.carpetaActual : null;
    // Params define el lugar donde se guarda
    const params = {
      Bucket: carpeta ? this.getBucket() + '/' + carpeta : this.getBucket(),
      Key: nombre + '/',
      ACL: 'public-read-write'
    };

    return this.getS3() != null ? this.getS3().putObject(params) : null;
  }

  /*
  async moveObject(oldKey: string, newKey: string) {
    const s3 = this.getS3();
    if (s3) {
      const bucket = this.getBucket();
      if (bucket && bucket != 'Error') {
        // Copia el objeto en la nueva ubicación
        await s3.copyObject({
          Bucket: bucket,
          CopySource: 'bucket/' + oldKey,
          Key: newKey
        }).promise().then(async (response) => {
          console.log(response);
          // Borra el objeto antiguo
          await s3.deleteObject({
            Bucket: bucket,
            Key: oldKey
          }).promise();
        });
      }
    }
  }
  */

  getFiles(): AWS.Request<S3.ListObjectsOutput, AWS.AWSError> {
    if (this.carpetaActual) {
      this.setRutaActual(this.carpetaActual);
    }
    else {
      this.setRutaActual('');
    }
    const params: S3.ListObjectsV2Request = {
      Bucket: this.getBucket(),
      Prefix: this.carpetaActual != null ? this.carpetaActual + '/' : '',
      Delimiter: '/'
    };

    return this.getS3() != null ? this.getS3().listObjectsV2(params) : null;
  }
  getFilesInCarpeta(KeyCarpeta: string): AWS.Request<S3.ListObjectsOutput, AWS.AWSError> {
    const params: S3.ListObjectsV2Request = {
      Bucket: this.getBucket(),
      Prefix: KeyCarpeta
    };

    return this.getS3() != null ? this.getS3().listObjectsV2(params) : null;
  }
  getFilesDeActivo(activo: Activo, folder?: string): AWS.Request<S3.ListObjectsOutput, AWS.AWSError> {
    const params: S3.ListObjectsV2Request = {
      Bucket: this.getBucket(),
      Prefix: `${activo.carpetaAWS}/${folder !== undefined ? folder : ''}`, // La carpeta viene SIN la "/"
      // Delimiter: '/'
    };

    return this.getS3() != null ? this.getS3().listObjectsV2(params) : null;
  }
  getAllFiles(): AWS.Request<S3.ListObjectsOutput, AWS.AWSError> {
    // Metodo para el dashboard
    const params: S3.ListObjectsV2Request = {
      Bucket: this.getBucket()
    };
    return this.getS3() != null ? this.getS3().listObjectsV2(params) : null;
  }

  descargarFichero(key, versionId?) {
    const params = !versionId ? {
      Bucket: this.getBucket(),
      Key: key
    } : {
        Bucket: this.getBucket(),
        Key: key,
        VersionId: versionId
      };

    // return params;
    if (this.getS3() != null) {
      this.getS3().getObject(params, function (err, data) {
        if (err) {
          console.log(err);
          return;
        }
        const blob = new Blob([data.Body], {
          type: ''
        });
        // Lo grabo con el nombre que viene despues de la ultima barra. Ej: Carpeta/archivo.pdf => archivo.pdf
        const arraySt = key.split('/');
        saveAs(blob, arraySt[arraySt.length - 1]);
      });
    }

  }
  getOptionToPrint(key, versionId?): AWS.Request<S3.GetObjectOutput, AWS.AWSError> {
    // Metodo similar al de descarga pero que dejará el callback en el file-list.component para imprimirlo
    const params = !versionId ? {
      Bucket: this.getBucket(),
      Key: key
    } : {
        Bucket: this.getBucket(),
        Key: key,
        VersionId: versionId
      };
    return this.getS3() != null ? this.getS3().getObject(params) : null;
  }

  deleteFile(file: Fichero): AWS.Request<S3.DeleteObjectOutput, AWS.AWSError> {
    const params = !file.versionElegida ? {
      Bucket: this.getBucket(),
      Key: file.key
    } : {
        Bucket: this.getBucket(),
        Key: file.key,
        VersionId: file.versionElegida
      };
    return this.getS3() != null ? this.getS3().deleteObject(params) : null;
  }
  subirVersionFichero(fileOriginal: Fichero, file: File): AWS.Request<S3.PutObjectOutput, AWS.AWSError> {
    const params = {
      Body: file,
      Bucket: this.getBucket(),
      Key: fileOriginal.key
    };
    return this.getS3() != null ? this.getS3().putObject(params) : null;
  }

  getDetalle(file: Fichero): AWS.Request<S3.ListObjectVersionsOutput, AWS.AWSError> {
    const params = {
      Bucket: this.getBucket(),
      Prefix: file.key
    };
    return this.getS3() != null ? this.getS3().listObjectVersions(params) : null;
  }
  getRutaActual(): Observable<string> {
    return this.rutaActual.asObservable();
  }
  setRutaActual(ruta) {
    this.rutaActual.next(ruta);
  }
  actualizarFicheros(ficheros) {
    this.onFilesChanged.next(ficheros);
  }
  getPdfQR(fichero: Fichero, version) {
    if (!this.clienteBucket && this.usuarioLogueado.rol.id === 1) {
      this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
      return null;
    }
    else if (this.usuarioLogueado.rol.id !== 1) {
      this.clienteBucket = this.usuarioLogueado.cliente;
    }

    const body = {
      'key': fichero.key,
      'versionId': version.VersionId,
      'clienteId': this.clienteBucket.id
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem('tokenBim')
    });
    const responseType = 'arraybuffer';

    return this.http.post(environment.urlBase + 'getPdf', body, { headers, responseType });
  }

  copyObject(ficheroACopiar: Fichero, carpetaDestino: string): AWS.Request<S3.CopyObjectOutput, AWS.AWSError> {
    const params = {
      Bucket: this.getBucket(), // Se entiende que el fichero se copia en otra carpeta DEL MISMO BUCKET
      CopySource: this.getBucket() + '/' + ficheroACopiar.key,
      Key: carpetaDestino + '/' + ficheroACopiar.name // La carpeta destino debe terminar SIN la barra "/" siempre (la pongo aqui)
    };
    // console.log(params);

    return this.getS3() != null ? this.getS3().copyObject(params) : null;
  }

  setFicheroDashboard(fichero: Fichero) {
    this.ficheroDashboard.next(fichero);
  }
  getFicheroDashboard() {
    return this.ficheroDashboard.asObservable();
  }
  getCarpetaDestino(): Observable<string> {
    return this.carpetaDestino.asObservable();
  }
  setCarpetaDestino(ruta) {
    this.carpetaDestino.next(ruta);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/file-manager/file-manager.service.ts